module.exports = "/_next/static/images/no-results-generic-fa767cca19c7fe51ae8aa7e9575ae915.svg";